import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { MdlFiltroRecuperacion } from "./MdlFiltroRecuperacion";

export const RecuperacionCarteraMain = () => {
  const history = useHistory();
  const location = useLocation();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  useEffect(() => {
    // onCargarRecuperacion();
  }, []);
  const onCargarRecuperacion = ({ fechainicio, fechafinal }) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      const post = {
        inicio: fechainicio,
        fin: fechafinal,
      };
      request
        .post("RecuperacionCartera/Obtener_Resumen", post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          resolve({ mensaje: "Consulta realizada" });
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
          //   Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
        });
    });
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  return (
    <PlantillaScreen
      titulo={"RECUPERACION DE CARTERA"}
      className_main={1}
      className={"recuperacion-cartera"}
    >
      <LoaderScreen loader={loader} />
      <MdlFiltroRecuperacion
        onCargarRecuperacion={onCargarRecuperacion}
        // recarga={recargar}
      />
      {data === undefined || data === null || data.length === 0 ? (
        <div></div>
      ) : (
        <div className="recuperacion-cartera-container-table scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Sucursal</th>
                <th>Vencido</th>
                <th>
                  <div>Recuperado</div>
                </th>
                <th>
                  <div>%</div>
                </th>
                <th>Por Vencer</th>
                <th>
                  <div>Recuperado</div>
                </th>
                <th>
                  <div>%</div>
                </th>
                <th>Activo</th>
                <th>
                  <div>Recuperado</div>
                </th>
                <th>
                  <div>%</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr>
                  <td>{capitalizeWords(item.sucursal)}</td>
                  <td>{FormatMoney(item.vencido)}</td>
                  <td>{FormatMoney(item.recuperado_vencido)}</td>
                  <td>{item.por_vencido}</td>

                  <td>{FormatMoney(item.porvencer)}</td>
                  <td>{FormatMoney(item.recuperado_porvencer)}</td>
                  <td>{item.por_porvencer}</td>

                  <td>{FormatMoney(item.activo)}</td>
                  <td>{FormatMoney(item.recuperado_activo)}</td>
                  <td>{item.por_activo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PlantillaScreen>
  );
};
